/* VendorResponseEditor.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _22 = "._1vgjviql._1vgjviql:focus, ._1sh5viql._1sh5viql:hover{height:2rem}";
const _21 = "._btpdviql._btpdviql{height:2rem}";
const _20 = "@media not all and (min-width:48rem){._14adidpf{margin-bottom:0}}";
const _19 = "._4cvr1h6o{align-items:center}";
const _18 = "._1bahesu3{justify-content:flex-end}";
const _17 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _16 = "._18s8va5m{margin:var(--ds-space-300,24px) 0 var(--ds-space-400,2pc) 0}";
const _15 = "._4t3i1ns9{height:-moz-fit-content;height:fit-content}";
const _14 = "._1bsb1osq{width:100%}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { Button } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _13 = "@media not all and (min-width:48rem){._15txfbnq{padding:var(--ds-space-200,1pc) var(--ds-space-150,9pt)}._a5zt1l7b{border-radius:3px}._17cqglyw{border-bottom:none}._1j3011bn{background-color:var(--ds-background-accent-gray-subtlest,#f1f2f4)}}";
const _12 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _11 = "._gy1putpp{column-gap:var(--ds-space-150,9pt)}";
const _10 = "._1e0c1txw{display:flex}";
const _9 = "._n7zlzgxb{border-bottom:1px solid var(--ds-border,#091e4224)}";
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._n3tdidpf{padding-bottom:0}";
const _6 = "._u5f3idpf{padding-right:0}";
const _5 = "._ca0qidpf{padding-top:0}";
const _4 = "._18u0idpf{margin-left:0}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._2hwxidpf{margin-right:0}";
const _ = "._19pkidpf{margin-top:0}";
export const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _n7zlzgxb _1e0c1txw _gy1putpp _19pkxy5q _15txfbnq _a5zt1l7b _17cqglyw _1j3011bn", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const Content = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _4t3i1ns9", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}
export const ActionsContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16, _17, _10, _18, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8va5m _zulpu2gc _1e0c1txw _1bahesu3 _4cvr1h6o _14adidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionsContainer.displayName = 'ActionsContainer';
}
export const ActionButton = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = Button,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_21, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_btpdviql _1vgjviql _1sh5viql", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionButton.displayName = 'ActionButton';
}